import {Epic} from 'redux-observable'
import {filter} from 'rxjs/operators'
import {mergeMap} from 'rxjs'
import {saveToClipboardFromCFModelAction, updateClipboardAction} from 'module/Clipboard/action/ClipbaordAction'
import {CF} from 'module/CustomField/util/CustomField'
import {CFAttrKey} from 'module/CustomField/constant/CFAttrConstants'

const saveByCFModelEpic: Epic = (action$, state$) => action$.pipe(
	filter(saveToClipboardFromCFModelAction.match),
	mergeMap(({payload: {model, cfDefs}}) => {
		return cfDefs.flatMap((cfDef) => {
			let clipboard = CF.getCFAttr(cfDef, CFAttrKey.ClipboardCopy)?.value?.trim()
			if (clipboard) {
				if (CF.isCFNamespace(cfDef)) {
					const dstField = CF.getCFNamespaceField(cfDef);
					const cf = model.cf?.flatMap((member) => member.dstField === dstField ? [{...member}] : [])
					return [updateClipboardAction({clipboard, value: cf})]
				} else {
					return [updateClipboardAction({clipboard, value: CF.getValueFrom(cfDef, model)})]
				}
			}
			clipboard = CF.getCFAttr(cfDef, CFAttrKey.ClipboardClear)?.value?.trim()
			if (clipboard) {
				return [updateClipboardAction({clipboard, value: null})]
			}
			return []
		})
	}),
)

export const ClipboardEpic = saveByCFModelEpic
